<template>
  <b-container fluid class="incidences-by">
    <h1 v-translate="{countdown}">Indicences By... <small>(Autorefresh in %{countdown}s)</small></h1>
    <b-row class="mb-3">
      <b-col>
        <b-form-radio-group v-model="theSubject" :options="[{text: $gettext('Couriers'), value: 'couriers'}, {text: $gettext('Companies'), value: 'companies'}]" />
      </b-col>
      <b-col v-if="!$cookies.get('bypassCountry') && warehousesSelect.length > 0">
        <b-form-group>
          <label for="filter-warehouse" v-translate>Select Origin Warehouse</label>
          <b-form-select class="w-auto" v-model="filterWarehouse" :options="warehousesSelect" @input="setTimeout">
            <template slot="first">
              <option :value="null" v-translate>None</option>
            </template>
          </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-if="!working && theList.length > 0">
      <b-col sm="6" md="4" lg="3" v-for="(subject, index) in theList" :key="index">
        <b-card>
          <user-card :user="subject" :with-map="false" :with-titles="false" :profile-picture="false" v-if="theSubject === 'couriers'" />
          <company-card :company="subject" :with-contact="false" :with-titles="false" :profile-picture="false" v-if="theSubject === 'companies'" />
          <h6>
            <a
              href="#"
              v-b-modal.modalShowCourierIncidences
              @click.prevent="selectedSubject = subject; label= 'danger'; shippings = subject.shippings.filter(x => x.status_history[0].created_at < moment().utc().subtract(3, 'days').format('YYYY-MM-DD HH:mm:ss')).sort(function (a, b) { return moment(a.status_history[0].created_at).format('YYYYMMDDHHmmss') - moment(b.status_history[0].created_at).format('YYYYMMDDHHmmss') })"
            >+72 hs</a>
            <b-badge variant="danger">
              {{subject.shippings.filter(x => x.status_history[0].created_at < moment().utc().subtract(3, 'days').format('YYYY-MM-DD HH:mm:ss')).length}}
            </b-badge>
          </h6>
          <h6>
            <a
              href="#"
              v-b-modal.modalShowCourierIncidences
              @click.prevent="selectedSubject = subject; label = 'danger'; shippings = subject.shippings.filter(x => x.status_history[0].created_at < moment().utc().subtract(2, 'days').format('YYYY-MM-DD HH:mm:ss') && x.status_history[0].created_at > moment().utc().subtract(3, 'days').format('YYYY-MM-DD HH:mm:ss')).sort(function (a, b) { return moment(a.status_history[0].created_at).format('YYYYMMDDHHmmss') - moment(b.status_history[0].created_at).format('YYYYMMDDHHmmss') })"
            >+48 hs</a>
            <b-badge variant="danger">
              {{subject.shippings.filter(x => x.status_history[0].created_at < moment().utc().subtract(2, 'days').format('YYYY-MM-DD HH:mm:ss') && x.status_history[0].created_at > moment().utc().subtract(3, 'days').format('YYYY-MM-DD HH:mm:ss')).length}}
            </b-badge>
          </h6>
          <h6>
            <a
              href="#"
              v-b-modal.modalShowCourierIncidences
              @click.prevent="selectedSubject = subject; label = 'warning'; shippings = subject.shippings.filter(x => x.status_history[0].created_at < moment().utc().subtract(1, 'day').format('YYYY-MM-DD HH:mm:ss') && x.status_history[0].created_at > moment().utc().subtract(2, 'days').format('YYYY-MM-DD HH:mm:ss')).sort(function (a, b) { return moment(a.status_history[0].created_at).format('YYYYMMDDHHmmss') - moment(b.status_history[0].created_at).format('YYYYMMDDHHmmss') })"
            >+24 hs</a>
            <b-badge variant="warning">
              {{subject.shippings.filter(x => x.status_history[0].created_at < moment().utc().subtract(1, 'day').format('YYYY-MM-DD HH:mm:ss') && x.status_history[0].created_at > moment().utc().subtract(2, 'days').format('YYYY-MM-DD HH:mm:ss')).length}}
            </b-badge>
          </h6>
          <hr>
          <p class="mb-0" v-if="theSubject === 'couriers'">{{subject.companies.join(', ')}}</p>
          <p class="mb-0" v-if="theSubject === 'companies'">{{subject.couriers.join(', ')}}</p>
        </b-card>
      </b-col>
    </b-row>
    <b-row v-else-if="working">
      <b-col>
        <div class="text-center">
          <h3>
            <b-spinner style="vertical-align: center" />
            <translate>Searching...</translate>
          </h3>
        </div>
      </b-col>
    </b-row>
    <b-row v-else>
      <b-col>
        <div class="text-center">
          <h3 v-translate>No results</h3>
        </div>
      </b-col>
    </b-row>

    <b-modal size="lg" ref="modalShowCourierIncidences" id="modalShowCourierIncidences" hide-footer @hide="shippings = []; label = null; selectedSubject = {}">
      <div slot="modal-title" v-translate>INCIDENCEs Details</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
      <user-card v-if="selectedSubject && theSubject === 'couriers'" :user="selectedSubject" />
      <company-card v-if="selectedSubject && theSubject === 'companies'" :company="selectedSubject" />
      <hr>
      <b-card v-for="(item, index) in shippings" :key="index">
        <b-row>
          <b-col cols="3">
            <div style="width: 1rem; height: 1rem; display: inline-block" :class="'bg-' + label"></div>
            <b-link :to="{ name: 'viewShipping', params: { id: item.id } }" target="_blank">#{{item.id | uuid}}</b-link>
          </b-col>
          <b-col>
            {{item.company.name}}
          </b-col>
          <b-col v-if="theSubject === 'companies' && item.courier">
            <b-link :to="{ name: 'viewUser', params: { id: item.courier_id } }" target="_blank">{{item.courier.name}}</b-link> <a v-if="item.courier.phone" class="btn btn-sm btn-secondary" style="padding: 0.1rem 1rem;" :href="$options.filters.whatsappize(item.courier.phone)">WhatsApp</a>
          </b-col>
          <b-col cols="2">
            {{elapsedTime(item.status_history[0].created_at, moment().utc().format('YYYY-MM-DD HH:mm:ss'))}}
          </b-col>
          <div style="position: absolute; top: 0; right: 0; padding: 0 5px; line-height: 1.2" class="bg-info text-white" v-if="item.tour_id">
            <b-link :to="{ name: 'viewTour', params: { id: item.tour_id } }" target="_blank" class="text-white"><small v-translate>In Tour</small></b-link>
          </div>
        </b-row>
      </b-card>
      <h3 v-if="shippings.length === 0" v-translate>No data</h3>
    </b-modal>
  </b-container>
</template>

<script>
export default {
  name: 'IndicencesByCourier',
  data() {
    return {
      couriers: [],
      companies: [],
      timeoutCountdown: null,
      intervalCountdown: null,
      countdown: 300,
      shippings: [],
      label: null,
      selectedSubject: {},
      theSubject: null,
      theList: [],
      filterWarehouse: null,
      working: false
    }
  },
  watch: {
    theSubject(val) {
      if (val === 'couriers') {
        this.theList = this.couriers
      } else {
        this.theList = this.companies
      }
    }
  },
  mounted() {
    this.fetchWarehouses()
      .then(() => {
        this.filterWarehouse = this.$cookies.get('warehouse') || null
        this.setTimeout()
      })
  },
  methods: {
    setTimeout() {
      this.working = true
      if (this.filterWarehouse) {
        this.$cookies.set('warehouse', this.filterWarehouse)
      } else {
        this.$cookies.remove('warehouse')
      }
      clearTimeout(this.timeoutCountdown)
      this.timeoutCountdown = setTimeout(() => { this.setTimeout() }, 300000)
      this.fetchIncidencesByCourier()
        .then(() => {
          this.setIntervalCountdown()
        })
    },
    setIntervalCountdown() {
      clearInterval(this.intervalCountdown)
      this.countdown = 300
      this.intervalCountdown = setInterval(function () {
        this.countdown = this.countdown === 0 ? 0 : this.countdown - 1
      }.bind(this), 1000)
    },
    async fetchIncidencesByCourier() {
      let params = {
        includes: [
          'status_history',
          'courier.courier_available.tracking'
        ],
        sort: [
          {
            key: 'updated_at',
            direction: 'asc'
          }
        ],
        filter_groups: [
          {
            filters: [
              ['status', 'eq', 'INCIDENCE'],
              ['updated_at', 'lte', this.moment().utc().subtract(1, 'day').format('YYYY-MM-DD HH:mm:ss')],
              ['courier_id', 'eq', 'null', 'true']
            ]
          }
        ]
      }

      if (!this.$cookies.get('bypassCountry')) {
        params.filter_groups.push(
          {
            filters: [
              ['from_country_iso_code', 'eq', window.country]
            ]
          }
        )
      }

      if (this.filterWarehouse) {
        params.filter_groups.push(
          {
            filters: [
              ['from_place_id', 'eq', this.filterWarehouse]
            ]
          }
        )
      }

      return this.$http.get(this.$appConfig.api.baseUrl + 'shippings', {params: params})
        .then(response => {
          let byCourier = {}
          let byCompany = {}
          response.body.data.forEach((item, i) => {
            if (!byCourier[item.courier.name]) {
              byCourier[item.courier.name] = item.courier
              byCourier[item.courier.name].failed = 1
              byCourier[item.courier.name].shippings = [item]
              byCourier[item.courier.name].companies = [item.company.name]
              byCourier[item.courier.name].roles = [
                {
                  name: 'courier'
                }
              ]
            } else {
              if (!byCourier[item.courier.name].failed) {
                byCourier[item.courier.name].failed = 1
              } else {
                byCourier[item.courier.name].failed = byCourier[item.courier.name].failed + 1
                byCourier[item.courier.name].shippings.push(item)
                byCourier[item.courier.name].companies.push(item.company.name)
                byCourier[item.courier.name].companies = [...new Set(byCourier[item.courier.name].companies)] // cleanup dupes
              }
            }

            if (!byCompany[item.company.name]) {
              byCompany[item.company.name] = item.company
              byCompany[item.company.name].failed = 1
              byCompany[item.company.name].shippings = [item]
              byCompany[item.company.name].couriers = [item.courier.name]
              byCompany[item.company.name].roles = [
                {
                  name: 'courier'
                }
              ]
            } else {
              if (!byCompany[item.company.name].failed) {
                byCompany[item.company.name].failed = 1
              } else {
                byCompany[item.company.name].failed = byCompany[item.company.name].failed + 1
                byCompany[item.company.name].shippings.push(item)
                byCompany[item.company.name].couriers.push(item.courier.name)
                byCompany[item.company.name].couriers = [...new Set(byCompany[item.company.name].couriers)] // cleanup dupes
              }
            }
          })
          console.log(response.body.data.length)
          this.couriers = Object.keys(byCourier).sort(function (a, b) { return byCourier[b].failed - byCourier[a].failed }).map(key => byCourier[key])
          this.companies = Object.keys(byCompany).sort(function (a, b) { return byCompany[b].failed - byCompany[a].failed }).map(key => byCompany[key])
          this.theSubject = this.theSubject || 'couriers'
          if (this.theSubject === 'couriers') {
            this.theList = this.couriers
          } else {
            this.theList = this.companies
          }
          this.working = false
          // this.theSubject = this.theSubject || 'couriers'
        })
    }
  }
}
</script>
